export const destinationRouteKey = (park) =>
  String(park?.url_key || park?.id || "").trim();

export const parkPath = (park) => `/park/${destinationRouteKey(park)}`;

export const trailSlugFromId = (trail) => {
  if (trail?.slug) return trail.slug;
  const id = String(trail?.id || "");
  const separator = id.indexOf("/");
  return separator >= 0 ? id.slice(separator + 1) : id;
};

export const trailPath = (trail) => {
  const park = trail?.park || trail?.destination;
  return `/trail/${destinationRouteKey(park)}/${trailSlugFromId(trail)}`;
};
